import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCombobox,
    _vm._b(
      {
        directives: [
          {
            name: "permissions",
            rawName: "v-permissions",
            value: ["tag.search"],
            expression: "['tag.search']",
          },
        ],
        attrs: {
          items: _vm.rows,
          "menu-props": {
            closeOnContentClick: true,
            value: _vm.input !== "",
          },
        },
        on: { keydown: _vm.searchTag },
        scopedSlots: _vm._u(
          [
            _vm.isSearching
              ? {
                  key: "append",
                  fn: function () {
                    return [
                      _c(VProgressCircular, {
                        attrs: { indeterminate: "" },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "append-item",
              fn: function () {
                return [
                  _c(VDivider),
                  _vm._v(" "),
                  _c(
                    VListItem,
                    { attrs: { link: "" }, on: { click: _vm.pushTag } },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("components.TTCTagField.propose", {
                              tag: _vm.input,
                            })
                          ) +
                          "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
        model: {
          value: _vm.vModel,
          callback: function ($$v) {
            _vm.vModel = $$v
          },
          expression: "vModel",
        },
      },
      "v-combobox",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }